import { setLocalStorage, getLocalStorage } from "./../../../helpers";
import store from "./../../store";

export default function useDiscountPopupu() {
  const key = "discount-popup",
    time = 5000;

  function onSubmit() {
    store.dispatch("discountPopup/CREATE_COUPON").then(({ data }) => {
      // succesfully generated coupon
      if (!data.error) {
        store.commit("discountPopup/SET_SENT", true);
      }
    });
  }

  function togglePopup(show) {
    store.commit("discountPopup/SET_SHOW", show);

    setLocalStorage(key, show);
  }

  function loadData() {
    const show = getLocalStorage(key);

    setTimeout(() => {
      store.commit("discountPopup/SET_SHOW", show === null || show === true);
    }, time);
  }

  return {
    onSubmit,
    togglePopup,
    loadData,
  };
}
